/**
 * Application Constants
 * Centralizes magic numbers and repeated values for better maintainability
 */

// Time constants (in milliseconds)
export const TIME = {
    SECOND: 1000,
    MINUTE: 60 * 1000,
    HOUR: 60 * 60 * 1000,

    // Auth validation intervals
    AUTH_VALIDATION_DEBOUNCE: 30 * 60 * 1000, // 30 minutes
    AUTH_VALIDATION_INTERVAL: 45 * 60 * 1000, // 45 minutes

    // Query stale times
    QUERY_STALE_TIME: 5 * 60 * 1000, // 5 minutes
} as const;

// File upload limits
export const FILE_LIMITS = {
    MAX_SIZE_MB: 10,
    MAX_SIZE_BYTES: 10 * 1024 * 1024,
    ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
    ALLOWED_DOCUMENT_TYPES: [
        'application/pdf',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        'text/csv',
    ],
} as const;

// Pagination defaults
export const PAGINATION = {
    DEFAULT_PAGE_SIZE: 10,
    PAGE_SIZE_OPTIONS: [10, 20, 50, 100] as const,
} as const;

// Priority options
export const PRIORITIES = ['high', 'medium', 'low'] as const;
export type Priority = typeof PRIORITIES[number];

// Task status options
export const TASK_STATUSES = [
    'to_do',
    'in_progress',
    'pending_approval',
    'completed',
    'on_hold',
    'cancelled'
] as const;
export type TaskStatus = typeof TASK_STATUSES[number];

// User roles
export const USER_ROLES = [
    'super_admin',
    'admin',
    'staff',
    'client'
] as const;
export type UserRole = typeof USER_ROLES[number];

// Document statuses
export const DOCUMENT_STATUSES = [
    'Uploaded',
    'Reviewed',
    'Approved',
    'Rejected',
    'Pending Review'
] as const;
export type DocumentStatus = typeof DOCUMENT_STATUSES[number];

// Compliance types
export const COMPLIANCE_TYPES = [
    'Income Tax',
    'GST',
    'MCA',
    'FEMA',
    'Other'
] as const;
export type ComplianceType = typeof COMPLIANCE_TYPES[number];
